module.exports = __webpack_public_path__ + "static/st1-7-1f1ffa8214ed99015aeec9a1c854e182.jpg";